import React from 'react';
import { connect } from 'react-redux';
import { appThemeSelector } from '../App/AppSelectors';

const Theme = ({ children, theme }) => (
  <div id="app-root" className={`theme-${theme}`}>
    {children}
  </div>
);

const mapStateToProps = (state) => ({
  theme: appThemeSelector(state),
});

export default connect(mapStateToProps)(Theme);
